// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api_proto/v1/deal_external_document.proto (package api_proto.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Upload } from "./file_pb";
import { file_api_proto_v1_file } from "./file_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api_proto/v1/deal_external_document.proto.
 */
export const file_api_proto_v1_deal_external_document: GenFile = /*@__PURE__*/
  fileDesc("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", [file_api_proto_v1_file, file_google_protobuf_timestamp]);

/**
 * 取り込み済みの外部書類 1 件。
 *
 * @generated from message api_proto.v1.DealExternalDocument
 */
export type DealExternalDocument = Message<"api_proto.v1.DealExternalDocument"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: int64 deal_id = 2;
   */
  dealId: bigint;

  /**
   * @generated from field: api_proto.v1.ExternalDocumentType document_type = 3;
   */
  documentType: ExternalDocumentType;

  /**
   * 実体 PDF (案件ファイル)。ファイル自体は deal_files が持つ
   *
   * @generated from field: int64 deal_file_id = 4;
   */
  dealFileId: bigint;

  /**
   * @generated from field: string file_name = 5;
   */
  fileName: string;

  /**
   * presigned GET URL (有効期限 1 時間)。DB 非保存
   *
   * @generated from field: string file_url = 6;
   */
  fileUrl: string;

  /**
   * @generated from field: api_proto.v1.ExternalDocumentExtractionStatus extraction_status = 7;
   */
  extractionStatus: ExternalDocumentExtractionStatus;

  /**
   * 案件詳細への反映に使う税抜合計。抽出できなかった場合は未設定
   *
   * @generated from field: optional double total_amount = 8;
   */
  totalAmount?: number;

  /**
   * @generated from field: optional double total_amount_tax_included = 9;
   */
  totalAmountTaxIncluded?: number;

  /**
   * 0.10 等。読み取れなかった場合は未設定
   *
   * @generated from field: optional double tax_rate = 10;
   */
  taxRate?: number;

  /**
   * 見積日 / 請求日
   *
   * @generated from field: optional google.protobuf.Timestamp document_date = 11;
   */
  documentDate?: Timestamp;

  /**
   * 案件詳細へ反映した時刻。未設定 = 未反映
   *
   * @generated from field: optional google.protobuf.Timestamp applied_at = 12;
   */
  appliedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp created = 13;
   */
  created?: Timestamp;
};

/**
 * Describes the message api_proto.v1.DealExternalDocument.
 * Use `create(DealExternalDocumentSchema)` to create a new message.
 */
export const DealExternalDocumentSchema: GenMessage<DealExternalDocument> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal_external_document, 0);

/**
 * PDF から読み取った金額・日付 (未保存)。
 * ExtractExternalDocument が返し、確認画面で人が確認したあと ImportExternalDocument にそのまま渡し戻す。
 * サーバーは確定時に再抽出しない (確認画面に出した値と保存する値をずらさないため)。
 *
 * @generated from message api_proto.v1.ExternalDocumentExtraction
 */
export type ExternalDocumentExtraction = Message<"api_proto.v1.ExternalDocumentExtraction"> & {
  /**
   * @generated from field: api_proto.v1.ExternalDocumentExtractionStatus extraction_status = 1;
   */
  extractionStatus: ExternalDocumentExtractionStatus;

  /**
   * 案件詳細への反映に使う税抜合計。読み取れなかった場合は未設定
   *
   * @generated from field: optional double total_amount = 2;
   */
  totalAmount?: number;

  /**
   * @generated from field: optional double total_amount_tax_included = 3;
   */
  totalAmountTaxIncluded?: number;

  /**
   * 0.10 等。読み取れなかった場合は未設定
   *
   * @generated from field: optional double tax_rate = 4;
   */
  taxRate?: number;

  /**
   * 見積日 / 請求日
   *
   * @generated from field: optional google.protobuf.Timestamp document_date = 5;
   */
  documentDate?: Timestamp;
};

/**
 * Describes the message api_proto.v1.ExternalDocumentExtraction.
 * Use `create(ExternalDocumentExtractionSchema)` to create a new message.
 */
export const ExternalDocumentExtractionSchema: GenMessage<ExternalDocumentExtraction> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal_external_document, 1);

/**
 * 読み取りのために R2 に仮置きした PDF。案件ファイル (deal_files) には未登録。
 * 取り込みを確定したときに案件ファイルとして登録する (FinalizeDealFileUpload と同じ形)。
 *
 * @generated from message api_proto.v1.StagedExternalDocumentFile
 */
export type StagedExternalDocumentFile = Message<"api_proto.v1.StagedExternalDocumentFile"> & {
  /**
   * {company_id}/{deal_id}/{uuid}/{file_name}
   *
   * @generated from field: string r2_key = 1;
   */
  r2Key: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;

  /**
   * @generated from field: int64 file_size = 3;
   */
  fileSize: bigint;
};

/**
 * Describes the message api_proto.v1.StagedExternalDocumentFile.
 * Use `create(StagedExternalDocumentFileSchema)` to create a new message.
 */
export const StagedExternalDocumentFileSchema: GenMessage<StagedExternalDocumentFile> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal_external_document, 2);

/**
 * PDF を読み取る。案件ファイル・外部書類・案件詳細のいずれも書き換えない。
 *
 * @generated from message api_proto.v1.ExtractExternalDocumentRequest
 */
export type ExtractExternalDocumentRequest = Message<"api_proto.v1.ExtractExternalDocumentRequest"> & {
  /**
   * @generated from field: int64 deal_id = 1;
   */
  dealId: bigint;

  /**
   * @generated from field: api_proto.v1.ExternalDocumentType document_type = 2;
   */
  documentType: ExternalDocumentType;

  /**
   * @generated from oneof api_proto.v1.ExtractExternalDocumentRequest.source
   */
  source: {
    /**
     * アップロードする PDF。20MB まで。金額の読み取りは先頭 10 ページのみを対象にする
     * (超過ページは拒否せず読まない。取り逃しは確認ダイアログで人が気付く)
     *
     * @generated from field: api_proto.v1.Upload document = 3;
     */
    value: Upload;
    case: "document";
  } | {
    /**
     * 既に案件ファイルにある PDF。種別はユーザーが指定する (自動判別しない)
     *
     * @generated from field: int64 deal_file_id = 4;
     */
    value: bigint;
    case: "dealFileId";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message api_proto.v1.ExtractExternalDocumentRequest.
 * Use `create(ExtractExternalDocumentRequestSchema)` to create a new message.
 */
export const ExtractExternalDocumentRequestSchema: GenMessage<ExtractExternalDocumentRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal_external_document, 3);

/**
 * @generated from message api_proto.v1.ExtractExternalDocumentResponse
 */
export type ExtractExternalDocumentResponse = Message<"api_proto.v1.ExtractExternalDocumentResponse"> & {
  /**
   * @generated from field: api_proto.v1.ExternalDocumentExtraction extraction = 1;
   */
  extraction?: ExternalDocumentExtraction;

  /**
   * source が document (アップロード) のときだけ設定する
   *
   * @generated from field: api_proto.v1.StagedExternalDocumentFile staged_file = 2;
   */
  stagedFile?: StagedExternalDocumentFile;
};

/**
 * Describes the message api_proto.v1.ExtractExternalDocumentResponse.
 * Use `create(ExtractExternalDocumentResponseSchema)` to create a new message.
 */
export const ExtractExternalDocumentResponseSchema: GenMessage<ExtractExternalDocumentResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal_external_document, 4);

/**
 * 確認画面で確定した外部書類を取り込む。
 * 1 トランザクションで「案件ファイル登録 (アップロードのみ) → 外部書類作成 → (apply_to_deal なら) 案件詳細へ反映」を行う。
 * 反映先は見積書: quotation_date / quotation_amount、請求書: billing_date / complete_amount。
 *
 * @generated from message api_proto.v1.ImportExternalDocumentRequest
 */
export type ImportExternalDocumentRequest = Message<"api_proto.v1.ImportExternalDocumentRequest"> & {
  /**
   * @generated from field: int64 deal_id = 1;
   */
  dealId: bigint;

  /**
   * @generated from field: api_proto.v1.ExternalDocumentType document_type = 2;
   */
  documentType: ExternalDocumentType;

  /**
   * @generated from oneof api_proto.v1.ImportExternalDocumentRequest.source
   */
  source: {
    /**
     * ExtractExternalDocument が返した仮置きファイル
     *
     * @generated from field: api_proto.v1.StagedExternalDocumentFile staged_file = 3;
     */
    value: StagedExternalDocumentFile;
    case: "stagedFile";
  } | {
    /**
     * @generated from field: int64 deal_file_id = 4;
     */
    value: bigint;
    case: "dealFileId";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: api_proto.v1.ExternalDocumentExtraction extraction = 5;
   */
  extraction?: ExternalDocumentExtraction;

  /**
   * true なら案件詳細にも反映する。金額を読み取れていない (failed) 場合は true にできない
   *
   * @generated from field: bool apply_to_deal = 6;
   */
  applyToDeal: boolean;
};

/**
 * Describes the message api_proto.v1.ImportExternalDocumentRequest.
 * Use `create(ImportExternalDocumentRequestSchema)` to create a new message.
 */
export const ImportExternalDocumentRequestSchema: GenMessage<ImportExternalDocumentRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal_external_document, 5);

/**
 * @generated from message api_proto.v1.ImportExternalDocumentResponse
 */
export type ImportExternalDocumentResponse = Message<"api_proto.v1.ImportExternalDocumentResponse"> & {
  /**
   * @generated from field: api_proto.v1.DealExternalDocument document = 1;
   */
  document?: DealExternalDocument;
};

/**
 * Describes the message api_proto.v1.ImportExternalDocumentResponse.
 * Use `create(ImportExternalDocumentResponseSchema)` to create a new message.
 */
export const ImportExternalDocumentResponseSchema: GenMessage<ImportExternalDocumentResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal_external_document, 6);

/**
 * 外部書類を削除する。実体 PDF (案件ファイル) は残す。
 *
 * @generated from message api_proto.v1.DeleteExternalDocumentRequest
 */
export type DeleteExternalDocumentRequest = Message<"api_proto.v1.DeleteExternalDocumentRequest"> & {
  /**
   * @generated from field: int64 external_document_id = 1;
   */
  externalDocumentId: bigint;
};

/**
 * Describes the message api_proto.v1.DeleteExternalDocumentRequest.
 * Use `create(DeleteExternalDocumentRequestSchema)` to create a new message.
 */
export const DeleteExternalDocumentRequestSchema: GenMessage<DeleteExternalDocumentRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal_external_document, 7);

/**
 * 外部書類の種別。
 *
 * @generated from enum api_proto.v1.ExternalDocumentType
 */
export enum ExternalDocumentType {
  /**
   * @generated from enum value: EXTERNAL_DOCUMENT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 見積書
   *
   * @generated from enum value: EXTERNAL_DOCUMENT_TYPE_QUOTATION = 1;
   */
  QUOTATION = 1,

  /**
   * 請求書
   *
   * @generated from enum value: EXTERNAL_DOCUMENT_TYPE_INVOICE = 2;
   */
  INVOICE = 2,
}

/**
 * Describes the enum api_proto.v1.ExternalDocumentType.
 */
export const ExternalDocumentTypeSchema: GenEnum<ExternalDocumentType> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_deal_external_document, 0);

/**
 * 金額抽出の結果ステータス。
 *
 * @generated from enum api_proto.v1.ExternalDocumentExtractionStatus
 */
export enum ExternalDocumentExtractionStatus {
  /**
   * @generated from enum value: EXTERNAL_DOCUMENT_EXTRACTION_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 税抜金額を確定できた (税抜が直接読めた / 税込と税率から逆算できた)
   *
   * @generated from enum value: EXTERNAL_DOCUMENT_EXTRACTION_STATUS_SUCCEEDED = 1;
   */
  SUCCEEDED = 1,

  /**
   * 税込しか読めず、税率 10% を仮定して逆算した。UI で仮定した旨を示す
   *
   * @generated from enum value: EXTERNAL_DOCUMENT_EXTRACTION_STATUS_PARTIAL = 2;
   */
  PARTIAL = 2,

  /**
   * 金額を読み取れなかった。取り込み自体は成功し、案件への反映は行わない
   *
   * @generated from enum value: EXTERNAL_DOCUMENT_EXTRACTION_STATUS_FAILED = 3;
   */
  FAILED = 3,
}

/**
 * Describes the enum api_proto.v1.ExternalDocumentExtractionStatus.
 */
export const ExternalDocumentExtractionStatusSchema: GenEnum<ExternalDocumentExtractionStatus> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_deal_external_document, 1);

